import React, { useState, useEffect, useMemo } from "react";
import { Button, Form, Table, Modal } from "react-bootstrap";

import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

import AddNotification from "./AddNotification";
import EditNotification from "./EditNotification";

const NotificationManagement = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [notifications, setNotifications] = useState([]);
    const [editNotification, setEditNotification] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const filteredNotifications = useMemo(() => {
        return notifications.filter((notification) => {
            return notification.not_title && notification.not_title.toLowerCase().includes(searchTerm.toLowerCase());
        });
    }, [notifications, searchTerm]);

    const handleCloseAddModal = () => {
        setShowAddModal(false);
    };
    const handleCloseEditModal = () => {
        setShowEditModal(false);
    };

    useEffect(() => {
        fetchAllNotification();
    }, []);

    const fetchAllNotification = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllNotification",
        });

        const output = response.data;

        setNotifications(output);
    };

    const handleEdit = async (notification) => {
        setEditNotification(notification);
        setShowEditModal(true);
    };

    const handleDelete = async (not_key) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it",
            });

            if (result.isConfirmed) {
                const response = await axios.post(BASE_URL + "API/apicall", {
                    security_key: security_key,
                    mode: "deleteNotification",
                    pk_not_key: not_key,
                });

                const output = response.data;

                if (output == 1) {
                    await Swal.fire("Deleted!", "The Notification has been successfully removed.", "success");
                    fetchAllNotification();
                }
            }
        } catch (error) {
            // Handle any errors here
            console.error("An error occurred: ", error);
        }
    };

    return (
        <div className="container mb-3">
            <ToastContainer position="top-center" />
            <div className="d-flex justify-content-between align-items-center admin-page-head">
                <h4>Notification Management</h4>
                {/* <Button variant="dark" onClick={() => setShowAddModal(true)} className="ms-2">
                    Add New Notification
                </Button> */}
            </div>

            <div className="mb-4">
                <Form>
                    <div className="row">
                        <div className="col-md-4">
                            <Form.Group>
                                <Form.Control type="text" placeholder="Search by name" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                            </Form.Group>
                        </div>
                    </div>
                </Form>
            </div>

            <div className="row">
                <div className="col-12 table-responsive">
                <table className="table table-striped table-bordered table-responsive-scroll">
                    <thead className="thead-dark">
                        <tr>
                            <th>Title</th>
                            <th>Message</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredNotifications.length === 0 ? (
                            <tr>
                                <td colSpan={6}>
                                    <h6 className="text-center">Data not available</h6>
                                </td>
                            </tr>
                        ) : (
                            Array.isArray(filteredNotifications) &&
                            filteredNotifications.map((notification) => (
                                <tr key={notification.id}>
                                    <td>{notification.not_title}</td>
                                    <td>{notification.not_message}</td>
                                    <td>
                                        <div className="actbtn-grp">
                                            <Button variant="outline-dark" onClick={() => handleEdit(notification)} className="px-2 py-1 me-2" data-bs-toggle="tooltip" title="Edit">
                                                <i className="fa-solid fa-pen-to-square"></i>
                                            </Button>
                                            <Button variant="outline-danger" className=" px-2 py-1" onClick={() => handleDelete(notification.pk_not_key)} data-bs-toggle="tooltip" title="Delete">
                                                <i className="fa-solid fa-trash"></i>
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                    </table>
            </div>
            </div>
            <AddNotification showModal={showAddModal} handleClose={handleCloseAddModal} fetchAllNotification={fetchAllNotification} />
            <EditNotification
                showModal={showEditModal}
                handleClose={handleCloseEditModal}
                fetchAllNotification={fetchAllNotification}
                notification={editNotification}
            />
        </div>
    );
};

export default NotificationManagement;
